export default function detectMobile() {
	return window.innerWidth < 1000;
}
